module.exports = __webpack_public_path__ + "6d13a984a9f3ece19e7059f7b0ed3925.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/camp4.jpeg
// module id = 1138
// module chunks = 0